import React, { useState } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import DescriptionIcon from "@mui/icons-material/Description";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";

// Botão único de exportação: o usuário escolhe no menu Excel ou PDF (e a
// orientação do PDF) na hora de exportar.
export default function ExportButton({
  onExcel,
  onPdf,
  disabled = false,
  label = null,
  style = null,
}) {
  const [anchorEl, setAnchorEl] = useState(null);

  const run = (fn) => {
    setAnchorEl(null);
    fn?.();
  };

  return (
    <>
      <button
        type="button"
        className="excel-btn"
        disabled={disabled}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        title="Exportar"
        style={style || { display: "flex", alignItems: "center", gap: 4, padding: "2px 6px" }}
      >
        <span style={{ display: "flex", alignItems: "center" }}>
          <DescriptionIcon sx={{ fontSize: 16, color: "#1b5e20" }} />
          <PictureAsPdfIcon sx={{ fontSize: 16, color: "#c62828" }} />
        </span>
        {label}
      </button>
      <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={() => setAnchorEl(null)}>
        <MenuItem dense onClick={() => run(onExcel)}>
          <ListItemIcon>
            <DescriptionIcon fontSize="small" sx={{ color: "#1b5e20" }} />
          </ListItemIcon>
          Excel
        </MenuItem>
        <MenuItem dense onClick={() => run(() => onPdf("portrait"))}>
          <ListItemIcon>
            <PictureAsPdfIcon fontSize="small" sx={{ color: "#c62828" }} />
          </ListItemIcon>
          PDF vertical
        </MenuItem>
        <MenuItem dense onClick={() => run(() => onPdf("landscape"))}>
          <ListItemIcon>
            <PictureAsPdfIcon fontSize="small" sx={{ color: "#c62828" }} />
          </ListItemIcon>
          PDF horizontal
        </MenuItem>
      </Menu>
    </>
  );
}
